import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme:{
    themes: {
      light:{
        primary: '#344955',
        secondary: '#232F34',
        accent: "#6ec749"
      }
    }
  }
});
